var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
import styled from 'styled-components'
export var Hoverable = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  &:hover {\n    background-color: ', ';\n  }\n'],
      ['\n  &:hover {\n    background-color: ', ';\n  }\n']
    )),
  function (p) {
    return p.hoverColor || 'gray'
  }
)
export var HoverableButton = styled.button(
  templateObject_2 ||
    (templateObject_2 = __makeTemplateObject(
      ['\n  &:hover {\n    background-color: ', ';\n  }\n'],
      ['\n  &:hover {\n    background-color: ', ';\n  }\n']
    )),
  function (p) {
    return p.hoverColor || 'gray'
  }
)
var templateObject_1, templateObject_2
//# sourceMappingURL=Hoverable.js.map
